import { render, staticRenderFns } from "./dataColumnAuth.vue?vue&type=template&id=125a82a5&"
import script from "./dataColumnAuth.vue?vue&type=script&lang=js&"
export * from "./dataColumnAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports